export const overrideRolePermissionsWithUserPermissions = (
  appDefaultPermissions,
  resourceDefaultPermissions,
  rolePermissions,
  permissionExceptions
) => {
  return {
    ...appDefaultPermissions,
    ...resourceDefaultPermissions,
    ...rolePermissions,
    ...permissionExceptions,
  };
};
